import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
    appBarSpacer: {
        minHeight: '64px',
        background: 'white',
    },
    header: {
        background: '#ECF2FF',
        display: 'flex',
        alignItems: 'center',
        padding: "0 10px",
        height: '58px',
        "& h2": {
            padding: '0px 0px',
            // fontSize: '22px',
            // fontWeight: 600,
            // lineHeight: '28.8px',
            // color: '#2D4D95',
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 600,
             fontSize: window.isMobileView ? window.isMobile425 ? 14:18:24,
            lineHeight: '29px',
            color: '#2D4D95',
        }
    },
    container: {
        padding: '10px',
        background: window.isIpadView ? 'white' : '',
    },


    disabledcls: {
        pointerEvents: 'none',
        cursor: 'not-allowed',
        opacity: 0.4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: window.isMobileView ? 'column' : '',

        gap: '5px',
  
        "& img": {
            width: '30px'
        },
        "& h6": {
            fontSize: '14px',

        }
    },


    accountType: {
        border: '1px solid #bebebe',
        padding: '5px 15px',
        borderRadius: '50px',
        background: '#ffffff',
        margin: 0,
    },
    floatRight: {
       marginLeft: 'auto',
    },

    PRofileTop:{
        position:'relative',
    },
  
    CoverSec: {
       
    },

    coverImg: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxHeight: window.isMobileView ? '200px':'unset',
        minHeight: window.isMobileView ? '200px':'unset',
        background: 'white',
        borderRadius: '10px',
        position: 'relative',
        alignSelf: 'center',
        objectFit: 'cover',
        
        "& img": {
            objectFit: 'cover',
            objectPosition: window.isMobileView ? 'left': 'center',
            maxHeight: window.isMobileView ? '200px':'unset',
            minHeight: window.isMobileView ? '200px':'unset',
            width:'100%',
            margin:'auto',
            // padding:'5px',
            borderRadius: '10px',
        }
    },
    whiteBox: {
        display: 'flex',
        alignItems:window.isIpadView? 'center' :'end',
        justifyContent: window.isIpadView?'center' : 'left',
        marginTop: window.isMobileView ? '-120px' :'-100px',
        marginLeft:window.isIpadView? '':'25px',
        marginBottom:'20px',
        gap:'20px',
        flexDirection:window.isIpadView ?  'column' : '',


    },
    profileImg: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: window.isMobileView ? '160px' :'170px',
        minWidth: window.isMobileView ? '160px' :'170px',
        background: '#ffffff',
        borderRadius: '15px',
        position: 'relative',
        alignSelf: 'center',
        objectFit: 'cover',
        border:'1px solid #bcbcbc',
        borderRadius:'50%',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
        "& img": {
            position: 'absolute',
            maxWidth:window.isMobileView ? '160px' : '170px',
            width: '100%',
            borderRadius: '50%',
            margin: 'auto',
            left: 0,
            height: window.isMobileView ? '160px' : '170px',
            padding: '2px',
            objectFit:'cover'
        }
    },
    CoverEditICon: {
        width: '34px !important',
        padding: '9px',
        zIndex: 4,
        right: '2px !important',
        bottom: '2px !important',
        left: 'unset !important',
        background: '#0049a3',
        borderRadius: '16px !important',
        cursor: 'pointer',
        height: 'unset !important',
        padding: '6px !important',
        position:'absolute !important',
        minHeight: '34px !important',
    },
    EditICon: {
        width: '34px !important',
        padding: '9px',
        zIndex: 4,
        right: '10px !important',
        bottom: '5px !important',
        left: 'unset !important',
        background: '#0049a3',
        borderRadius: '16px !important',
        cursor: 'pointer',
        height: 'unset !important',
        padding: '6px !important',
    },

    accountCardMember: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '18px',
        lineHeight: '17px',
        color: 'black',
    },
    accountCardOrganisationName: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        color: 'black',
        textTransform: 'capitalize',
    },

    AccountName:{
        display:'flex',
        gap:'10px',
        paddingBottom:'20px',
        flexDirection:window.isIpadView ?  'column' : '',
        alignItems:'center'
    },

    sectionHeading: {
        fontSize: '22px',
        fontWeight: '600',
        margin: '10px 0',
    },
    changeLink: {
        display: 'inline-block',
        float: 'right',
        color: '#0686D8',
        fontFamily: 'Lato',
        fontWeight: 400,
        fontSize: '14px',
        cursor: 'pointer',
        marginLeft: 'auto',
        position: 'absolute',
        top: '4px',
        right: '4px',
    },

    QuickLinksMain:{
       
        textAlign: 'center',
        padding: '20px',
        borderRadius: '20px',
        position:'relative',
        minHeight: '190px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    figgersEligibleCard: {
        display: "flex",
        alignItems: 'center',
        width: window.isIpadView ? '100%': '100%',
        height: '175px',
        padding: "20px",
        borderRadius: "15px",
        backgroundColor: '#0049A3',
        cursor: 'pointer',
    },
    offersContainer: {
        border: '1px solid #e4e2e2',
        background: 'white',
        borderRadius: '15px',
        marginTop: '8px',
        "& .paperTitle": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: 20,
            lineHeight: '24px',
            color: '#3C4549',
            padding: '15px 0px 0px 15px',
        },
    },
    OffersTop:{
        fontSize: window.isMobileView? '28px':'48px',
        textAlign: 'center',
        marginTop: '40px',
        marginBottom: '10px',
        "& span":{
            color:'#0049a3',
            fontWeight: 'bold',
        }
},

prrfileMain:{
    background:'#fff',
    position: 'relative',
    padding: '20px 20px 0 20px',
    borderRadius:'10px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',


},
profileContain:{

    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    "& h5":{
        fontSize: '24px',
        paddingTop: '15px',
        fontWeight: '700 !important',
        lineHeight: '28px',
    },
    "& p":{
        fontSize: '14px',
        fontWeight: '400 !important',
        lineHeight: '16.8px',
    }

},

accountSection:{
    paddingBottom:'10px',
"& h4":{
    fontSize: '14px',
    fontWeight: '400 !important',
    lineHeight: '16.8px', 
    paddingBottom:'5px',
    color:'black'
}
},

corporateProfile:{
    minHeight: window.isMobileView ? '120px' :'140px',
    minWidth: window.isMobileView ? '120px' :'140px',
    background: '#ffffff',
    borderRadius: '15px',
    position: 'relative',
    alignSelf: 'center',
    objectFit: 'cover',
    borderRadius:'50%',
    "& img": {
        maxWidth:window.isMobileView ? '120px' : '140px',
        width: '100%',
        borderRadius: '50%',
        margin: 'auto',
        height: window.isMobileView ? '120px' : '140px',
        padding: '2px',
        objectFit:'cover'
    }
},
profileGrid:{
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
},

EditIConMain: {
    width: '34px !important',
    padding: '9px',
    zIndex: 4,
    right: '10px   !important',
    bottom: '10px  !important',
    background: '#0049a3',
    borderRadius: '16px !important',
    cursor: 'pointer',
    height: 'unset !important',
    padding: '6px !important',
    position: 'absolute !important',

},
iconMian:{
    display: 'flex',
    justifyContent: 'end',
    "& img":{
        width:'30px'
    }
},

QuickLinksNew:{
    textAlign: 'center',
    padding: '20px',
    borderRadius: '20px',
    position:'relative',
    display: 'flex',
    alignItems: 'center',
    minHeight:'145px',
    maxHeight:'145px',
    justifyContent: window.isMobileView?  'center' : '',
},
QuickLinksRight:{
    textAlign: 'center',
    padding: '20px',
    borderRadius: '20px',
    position:'relative',
    display: 'flex',
    alignItems: 'center',
    minHeight:'130px',
    maxHeight:'130px'
    // justifyContent: 'center',
},
QuickLinkscontain:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: window.isMobileView? 'column':'',
    gap:'10px',
    "& img":{
        width:'50px'
    }
},
ResQuickLinks:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: window.isMobileView? 'column':'',

    gap:'5px',
    cursor:'pointer',
    "& img":{
        width:'30px'
    },
    "& h6" :{
        fontSize:'14px',
        
    }
},
accountHomeTitle: {
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontSize: '18px',
    lineHeight: '24px',
    color:'#fff',

},

notifications:{
    background: '#76CABB',
    "&:hover":{
        background: 'linear-gradient(180deg, #76CABB 0%, #284f48 100%)',
        cursor:'pointer'
    },
   
},

phoneBook:{
    background: '#6889C7',
    "&:hover":{
        background: 'linear-gradient(180deg, #6889C7 0%, #253046 100%)',
        cursor:'pointer'
    },
},

ShoppingBag:{
    background: '#774A9B',
    "&:hover":{
        background: 'linear-gradient(180deg, #774A9B 0%, #2d193d  100%)',
        cursor:'pointer'
    },
},
file:{
    background: '#9AA2E9',
    "&:hover":{
        background: 'linear-gradient(180deg, #9AA2E9 0%, #2a2e53  100%)',
        cursor:'pointer'
    },
},

billing:{
    background: '#774A9B',
    "&:hover":{
        background: 'linear-gradient(180deg, #774A9B 0%, #160d1e  100%)',
        cursor:'pointer'
    },
},


addNewLine:{
    background: '#FFB13A',
    "&:hover":{
        background: 'linear-gradient(180deg, rgba(255, 177, 58, 1) 0%, rgb(157 95 0) 100%)',
        cursor:'pointer'
    },
   
},
portIn:{
    background:'#9AA2E9',
 "&:hover":{
        background: 'linear-gradient(180deg, rgb(154, 162, 233) 0%, rgb(76 81 118) 100%)',
        cursor:'pointer'
    },
},
updateSim:{
    background:'#76CABB',
 "&:hover":{
        background: 'linear-gradient(180deg, #76CABB 0%, #356058 100%)',
        cursor:'pointer'
    },
    
},

simCard:{
    background:'#774A9B',
 "&:hover":{
        background: 'linear-gradient(180deg, #774A9B 0%, #15091e 100%)',
        cursor:'pointer'
    },
    
},

noSim:{
    background:'#F56C6C',
 "&:hover":{
        background: 'linear-gradient(180deg, #F56C6C 0%, #602525 100%)',
        cursor:'pointer'
    },
    
},


password:{
    background:'#6889C7',
 "&:hover":{
        background: 'linear-gradient(180deg, #6889C7 0%, #273248 100%)',
        cursor:'pointer'
    },
    
},


bill:{
    background:'#3CBA48',
 "&:hover":{
        background: 'linear-gradient(180deg, #3CBA48 0%, #124a18 100%)',
        cursor:'pointer'
    },
    
},
figgersContainer:{
    marginBottom: window.isIpadView?'100px' : '',
}
}))